import BaseModelAPI from '../BaseModelAPI';

export default class PartPurchaseQualityControl extends BaseModelAPI {
	static entity = 'partpurchasequalitycontrol';
	static entityName = 'partpurchasequalitycontrol';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partPurchaseQualityControlDate = '';
			this.description = '';
			this.qcQty = 0;
			this.partPurchaseQualityControlDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}